var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.641 0H4.33178C2.19667 0 0.46582 1.7269 0.46582 3.85714V14.1429C0.46582 16.2731 2.19667 18 4.33178 18H14.641C16.7761 18 18.507 16.2731 18.507 14.1429V3.85714C18.507 1.7269 16.7761 0 14.641 0Z",
    fill: "url(#paint0_radial_3070_22754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.641 0H4.33178C2.19667 0 0.46582 1.7269 0.46582 3.85714V14.1429C0.46582 16.2731 2.19667 18 4.33178 18H14.641C16.7761 18 18.507 16.2731 18.507 14.1429V3.85714C18.507 1.7269 16.7761 0 14.641 0Z",
    fill: "url(#paint1_radial_3070_22754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.641 0H4.33178C2.19667 0 0.46582 1.7269 0.46582 3.85714V14.1429C0.46582 16.2731 2.19667 18 4.33178 18H14.641C16.7761 18 18.507 16.2731 18.507 14.1429V3.85714C18.507 1.7269 16.7761 0 14.641 0Z",
    fill: "url(#paint2_radial_3070_22754)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.9965 5.46429C13.9965 5.99683 13.5637 6.42857 13.03 6.42857C12.4962 6.42857 12.0635 5.99683 12.0635 5.46429C12.0635 4.93172 12.4962 4.5 13.03 4.5C13.5637 4.5 13.9965 4.93172 13.9965 5.46429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.48628 12.2137C11.2655 12.2137 12.7079 10.7746 12.7079 8.99944C12.7079 7.22426 11.2655 5.78516 9.48628 5.78516C7.70704 5.78516 6.26465 7.22426 6.26465 8.99944C6.26465 10.7746 7.70704 12.2137 9.48628 12.2137ZM9.48628 10.928C10.5539 10.928 11.4193 10.0646 11.4193 8.99944C11.4193 7.93429 10.5539 7.07087 9.48628 7.07087C8.4187 7.07087 7.5533 7.93429 7.5533 8.99944C7.5533 10.0646 8.4187 10.928 9.48628 10.928Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04297 8.74369C3.04297 6.5835 3.04297 5.50337 3.46433 4.6783C3.83498 3.95253 4.42639 3.36247 5.15382 2.99267C5.98078 2.57227 7.06338 2.57227 9.22851 2.57227H9.74397C11.9091 2.57227 12.9917 2.57227 13.8186 2.99267C14.5461 3.36247 15.1375 3.95253 15.5081 4.6783C15.9295 5.50337 15.9295 6.5835 15.9295 8.74369V9.25798C15.9295 11.4182 15.9295 12.4983 15.5081 13.3233C15.1375 14.0491 14.5461 14.6392 13.8186 15.009C12.9917 15.4294 11.9091 15.4294 9.74397 15.4294H9.22851C7.06338 15.4294 5.98078 15.4294 5.15382 15.009C4.42639 14.6392 3.83498 14.0491 3.46433 13.3233C3.04297 12.4983 3.04297 11.4182 3.04297 9.25798V8.74369ZM9.22851 3.85798H9.74397C10.8478 3.85798 11.5981 3.85898 12.1782 3.90626C12.7432 3.95231 13.0321 4.03579 13.2336 4.13825C13.7186 4.38478 14.1128 4.77816 14.3599 5.26198C14.4626 5.46307 14.5463 5.75132 14.5925 6.31504C14.6398 6.89374 14.6409 7.64235 14.6409 8.74369V9.25798C14.6409 10.3593 14.6398 11.1079 14.5925 11.6866C14.5463 12.2504 14.4626 12.5386 14.3599 12.7397C14.1128 13.2235 13.7186 13.6169 13.2336 13.8634C13.0321 13.9659 12.7432 14.0494 12.1782 14.0954C11.5981 14.1427 10.8478 14.1437 9.74397 14.1437H9.22851C8.12465 14.1437 7.37433 14.1427 6.7943 14.0954C6.22929 14.0494 5.94038 13.9659 5.73883 13.8634C5.25391 13.6169 4.85963 13.2235 4.61253 12.7397C4.50984 12.5386 4.42617 12.2504 4.38001 11.6866C4.33263 11.1079 4.33162 10.3593 4.33162 9.25798V8.74369C4.33162 7.64235 4.33263 6.89374 4.38001 6.31504C4.42617 5.75132 4.50984 5.46307 4.61253 5.26198C4.85963 4.77816 5.25391 4.38478 5.73883 4.13825C5.94038 4.03579 6.22929 3.95231 6.7943 3.90626C7.37433 3.85898 8.12465 3.85798 9.22851 3.85798Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3070_22754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.90909 13.5) rotate(-55.3146) scale(16.4176 16.4308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3070_22754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.26476 18.6429) rotate(-65.0863) scale(14.5307 14.5522)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3070_22754",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.50067 0.642857) rotate(-8.1118) scale(25.0573 5.34776)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagramICON.2e74e4665b4b3fe10245b47345e8015b.svg";
export { ForwardRef as ReactComponent };